import React from "react";

const TemplateFour = ({ title, headers, rows, inputValues, disabledInputs, onChange }) => (
  <table style={{ borderCollapse: "collapse", width: "100%", marginBottom: "20px" }}>
    <thead>
    
      {headers.map((row, rowIndex) => (
        <tr key={rowIndex}>
          {row.map((header, headerIndex) => (
            <th key={headerIndex} rowSpan={header.rowSpan} colSpan={header.colSpan}>
              {header.text}
            </th>
          ))}
        </tr>
      ))}
    </thead>
    <tbody>
      {rows.map((row, rowIndex) => (
        <tr key={rowIndex}>
          <td>{row.rowNumber}</td>
          <td>{row.description}</td>
          {row.values.map((name, valueIndex) => (
            <td key={valueIndex}>
              <input
                type="text"
                value={inputValues[name]}
                onChange={(e) => onChange(name, e.target.value)}
                disabled={disabledInputs[name] || false}
                style={{
                  width: "100%",
                  padding: "4px",
                  boxSizing: "border-box",
                  backgroundColor: disabledInputs[name] ? "#f0f0f0" : "white",
                }}
              />
            </td>
          ))}
        </tr>
      ))}
    </tbody>
  </table>
);

export default TemplateFour;
